// Main Mock Data Index
// 主要模擬數據索引

import { hkdseMathsExams } from './hkdse_maths_mockdata';
import { hkdseOtherExams } from './hkdse_other_mockdata';
import { programmingExams } from './programming_mockdata';
import { hkdseMathsCompleteExams } from './hkdse_maths_complete';
import { hkdseChineseExtended } from './hkdse_chinese_extended';
import { hkdseEnglishExtended } from './hkdse_english_extended';
import { hkdseChineseComplete } from './hkdse_chinese_complete';
import { hkdseChineseEnglishExtended } from './hkdse_chinese_english_extended';
import { paper2RemainingQuestions } from './hkdse_maths_paper2_remaining';
import { paper3RemainingQuestions } from './hkdse_maths_paper3_remaining';

// Combine all exam data
export const examQuestionBank = [
  ...programmingExams,
  ...hkdseOtherExams,
  ...hkdseMathsExams,
  ...hkdseMathsCompleteExams,
  ...hkdseChineseExtended,
  ...hkdseEnglishExtended,
  ...hkdseChineseComplete,
  ...hkdseChineseEnglishExtended
];

// Student exam records (keep existing structure)
export const studentExamRecords = [
  {
    studentId: 1,
    examId: 1,
    mode: 'examMode',
    startTime: '2025-06-20T10:00:00',
    endTime: '2025-06-20T11:15:00',
    score: 85,
    totalQuestions: 30,
    correctAnswers: 26,
    timeSpent: 75, // 分鐘
    status: 'completed',
    answers: [
      { questionId: 1, selectedAnswer: 0, isCorrect: true, timeSpent: 45 },
      { questionId: 2, selectedAnswer: 2, isCorrect: true, timeSpent: 30 }
    ],
    reviewNotes: '需要加強閉包和異步編程概念'
  },
  {
    studentId: 1,
    examId: 16, // HKDSE Math Paper 1
    mode: 'studyMode',
    startTime: '2025-06-18T14:30:00',
    endTime: null,
    score: null,
    totalQuestions: 30,
    correctAnswers: 15,
    timeSpent: 45,
    status: 'in_progress',
    answers: [
      { questionId: 1, selectedAnswer: 1, isCorrect: true, timeSpent: 60 }
    ],
    reviewNotes: '數學表達式理解需要加強'
  }
];

// Mock exam data (general exam info, not questions)
export const mockExams = [
  {
    id: 1, 
    name: '中文語文認證考試', 
    nameEn: 'Chinese Language Certification',
    nameCn: '中文语文认证考试',
    nameJa: '中国語認定試験',
    date: '2025-07-15', 
    time: '09:00', 
    fee: 150, 
    status: 'upcoming',
    course: '中文語文基礎', 
    courseId: 1, 
    duration: '120分鐘', 
    participants: 245,
    description: '全面測試中文語法、詞彙、閱讀和寫作能力。',
    descriptionEn: 'Comprehensive test of Chinese grammar, vocabulary, reading and writing.',
    descriptionCn: '全面测试中文语法、词汇、阅读和写作能力。',
    descriptionJa: '中国語の文法、語彙、読解、ライティング能力を総合的にテストします。',
    examType: '認證考試', 
    difficulty: 'intermediate', 
    totalQuestions: 80,
    passingScore: 70, 
    maxScore: 100, 
    examFormat: '線上考試'
  },
  {
    id: 2,
    name: 'JavaScript 基礎認證',
    nameEn: 'JavaScript Fundamentals Certification',
    nameCn: 'JavaScript 基础认证',
    nameJa: 'JavaScript基礎認定',
    date: '2025-07-20',
    time: '14:00',
    fee: 200,
    status: 'upcoming',
    course: '網頁前端開發',
    courseId: 2,
    duration: '90分鐘',
    participants: 189,
    description: '測試JavaScript基本語法、變數、函數和DOM操作知識。',
    descriptionEn: 'Test JavaScript basic syntax, variables, functions and DOM manipulation.',
    descriptionCn: '测试JavaScript基本语法、变量、函数和DOM操作知识。',
    descriptionJa: 'JavaScriptの基本構文、変数、関数、DOM操作の知識をテストします。',
    examType: '技能認證',
    difficulty: 'beginner',
    totalQuestions: 30,
    passingScore: 70,
    maxScore: 100,
    examFormat: '線上考試'
  },
  {
    id: 3,
    name: 'HKDSE Mathematics 數學科',
    nameEn: 'HKDSE Mathematics',
    nameCn: 'HKDSE 数学',
    nameJa: 'HKDSE 数学',
    date: '2025-08-15',
    time: '09:00',
    fee: 300,
    status: 'upcoming',
    course: '香港中學文憑考試',
    courseId: 3,
    duration: '135分鐘',
    participants: 450,
    description: '香港中學文憑考試數學科，包含代數、幾何、統計等內容。',
    descriptionEn: 'HKDSE Mathematics covering algebra, geometry, statistics and more.',
    descriptionCn: '香港中学文凭考试数学科，包含代数、几何、统计等内容。',
    descriptionJa: '香港中等教育卒業証明書試験の数学科目で、代数、幾何、統計などを含みます。',
    examType: '公開考試',
    difficulty: 'advanced',
    totalQuestions: 30,
    passingScore: 50,
    maxScore: 100,
    examFormat: '線上考試'
  }
];

// User data
export const userData = {
  1: {
    id: 1,
    name: '張小明',
    nameEn: 'Zhang Xiaoming',
    nameCn: '张小明',
    nameJa: '張小明',
    email: 'xiaoming@example.com',
    avatar: '/avatars/student1.jpg',
    role: 'student',
    enrolledCourses: [1, 2, 3],
    completedExams: [1],
    totalStudyTime: 45.5,
    achievements: ['first_exam', 'study_streak_7'],
    preferences: {
      language: 'zh-TW',
      theme: 'light',
      notifications: true
    }
  }
};

// Course data
export const courseData = [
  {
    id: 1,
    name: '中文語文基礎',
    nameEn: 'Chinese Language Fundamentals',
    nameCn: '中文语文基础',
    nameJa: '中国語基礎',
    instructor: '李老師',
    instructorEn: 'Teacher Li',
    duration: '8週',
    durationEn: '8 weeks',
    students: 245,
    rating: 4.8,
    price: 1200,
    originalPrice: 1500,
    description: '從基礎語法到進階寫作，全面提升中文能力',
    descriptionEn: 'From basic grammar to advanced writing, comprehensively improve Chinese skills',
    category: 'language',
    level: 'beginner',
    image: '/images/chinese-course.jpg'
  },
  {
    id: 2,
    name: '網頁前端開發',
    nameEn: 'Frontend Web Development',
    nameCn: '网页前端开发',
    nameJa: 'フロントエンドウェブ開発',
    instructor: '王工程師',
    instructorEn: 'Engineer Wang',
    duration: '12週',
    durationEn: '12 weeks',
    students: 189,
    rating: 4.9,
    price: 2500,
    originalPrice: 3000,
    description: '學習HTML、CSS、JavaScript，打造現代化網站',
    descriptionEn: 'Learn HTML, CSS, JavaScript to build modern websites',
    category: 'programming',
    level: 'intermediate',
    image: '/images/frontend-course.jpg'
  },
  {
    id: 3,
    name: '香港中學文憑考試數學',
    nameEn: 'HKDSE Mathematics',
    nameCn: '香港中学文凭考试数学',
    nameJa: 'HKDSE数学',
    instructor: '陳數學老師',
    instructorEn: 'Math Teacher Chen',
    duration: '24週',
    durationEn: '24 weeks',
    students: 450,
    rating: 4.7,
    price: 3500,
    originalPrice: 4000,
    description: 'HKDSE數學科全面備考，涵蓋代數、幾何、統計',
    descriptionEn: 'Comprehensive HKDSE Math preparation covering algebra, geometry, statistics',
    category: 'mathematics',
    level: 'advanced',
    image: '/images/hkdse-math-course.jpg'
  }
];

// Export all data
export {
  hkdseMathsExams,
  hkdseOtherExams,
  programmingExams,
  hkdseMathsCompleteExams,
  hkdseChineseExtended,
  hkdseEnglishExtended,
  hkdseChineseComplete,
  hkdseChineseEnglishExtended,
  paper2RemainingQuestions,
  paper3RemainingQuestions
}; 